// extracted by mini-css-extract-plugin
export var fadeInOut = "_16-3";
export var icon = "_16-4";
export var savedIndicator = "_16-2";
export var savingIndicator = "_16-0";
export var spin = "_16-1";